import ProductApi from "@/api/ProductApi";
import CategoryApi from "@/api/CategoryApi";
import OrderApi from "@/api/OrderApi";
import { AccountApi } from "@/api/AccountApi";
import CartApi from "@/api/CartApi";
import PaymentApi from "@/api/PaymentApi";
import PlatformApi from "@/api/PlatformApi";
import MarketingApi from "@/api/MarketingApi";

export default class Api {

  private static _payment: PaymentApi = PaymentApi.of();
  private static _platform: PlatformApi = PlatformApi.of();
  private static _category: CategoryApi = CategoryApi.of();
  private static _cart: CartApi = CartApi.of();
  private static _order: OrderApi = OrderApi.of();
  private static _product: ProductApi = ProductApi.of();
  private static _account: AccountApi = AccountApi.of();
  private static _marketing: MarketingApi = MarketingApi.of();

  public static get payment(): PaymentApi {
    return Api._payment;
  }

  public static get platform(): PlatformApi {
    return Api._platform;
  }

  public static get category(): CategoryApi {
    return Api._category;
  }

  public static get cart(): CartApi {
    return Api._cart;
  }

  public static get order(): OrderApi {
    return Api._order;
  }

  public static get product(): ProductApi {
    return Api._product;
  }

  public static get account(): AccountApi {
    return Api._account;
  }

  public static get marketing(): MarketingApi {
    return Api._marketing;
  }
}